import { SliderComponent } from './slider.component';
import { SliderTemplateDirective } from './template';

export const SLIDER_DECLARATIONS: any[] = [
  SliderComponent,
  SliderTemplateDirective,
];
